import { z } from 'zod';

export const blogCommentDocumentSchema = z.object({
  author_id: z.string(),
  author_name: z.string(),
  blog_id: z.string(),
  comment: z.string(),
  comment_id: z.string(),
  parent_id: z.string().nullable(),
  pfp_url: z.string(),
  timestamp: z.number().default(() => Date.now()),
  reply_ids: z.array(z.string()),
});

export const blogDocumentSchema = z.object({
  id: z.string(),
  uid: z.string(),
  slug: z.string(),
  title: z.string(),
  author: z.string(),
  thumbnail: z.string(),
  full_image: z.string(),
  html: z.string().default(''),
  tags: z.array(z.string()),
  categories: z.array(z.object({
    name: z.string(),
    slug: z.string()
  })).optional(),
  created: z.number().default(() => Date.now()),
  // WordPress `post_modified`, as a WP date string. Optional because it is fetched
  // separately from the persisted GraphQL query (which does not select it) and any
  // failure there must degrade to "unknown" rather than block the post from
  // rendering. Absent => callers omit dateModified entirely.
  modified: z.string().optional(),
  is_featured: z.boolean().default(false),
  is_published: z.boolean().default(true),
  description: z.string(),
  meta_tags: z.object({
    title: z.string(),
    keywords: z.string(),
    description: z.string()
  }),
  brands: z.array(z.string()).optional()
});

export type BlogCommentDocument = z.infer<typeof blogCommentDocumentSchema>;
export type BlogDocument = z.infer<typeof blogDocumentSchema>;
